import { forwardRef } from 'react'
import { cn } from '@/utils/cn'

const VARIANTS = {
  primary: 'bg-coral text-white hover:bg-coral-500 shadow-card',
  secondary: 'bg-white text-charcoal border border-charcoal-200 hover:border-charcoal',
  ghost: 'text-charcoal hover:bg-sand-200',
  outline: 'border border-white text-white hover:bg-white/10',
  messenger: 'bg-[#0084FF] text-white hover:bg-[#006fd6]',
  danger: 'bg-coral-600 text-white hover:bg-coral-700',
}

const SIZES = {
  sm: 'h-9 px-4 text-sm',
  md: 'h-11 px-6 text-sm',
  lg: 'h-12 px-8 text-base',
  xl: 'h-14 px-10 text-base',
}

/**
 * Generic button. Use `as="a"` (or `to=` for a Link) to render a link instead.
 * Prefer this over raw `<button>` so every CTA picks up the same focus state.
 */
export const Button = forwardRef(function Button(
  {
    children,
    variant = 'primary',
    size = 'md',
    fullWidth = false,
    pill = true,
    className,
    as: Tag = 'button',
    ...props
  },
  ref
) {
  return (
    <Tag
      ref={ref}
      className={cn(
        'inline-flex items-center justify-center gap-2 font-semibold transition',
        'focus:outline-none focus-visible:ring-2 focus-visible:ring-coral focus-visible:ring-offset-2',
        'disabled:cursor-not-allowed disabled:opacity-60',
        pill ? 'rounded-full' : 'rounded-lg',
        fullWidth && 'w-full',
        VARIANTS[variant],
        SIZES[size],
        className
      )}
      {...props}
    >
      {children}
    </Tag>
  )
})
